import * as yup from 'yup';

const forgotPasswordSchema = yup.object({
    email: yup
      .string()
      .required('Please enter email address!')
});

export default forgotPasswordSchema;
